export type HapticKind = 'tap' | 'success' | 'error' | 'warning';

const PATTERNS: Record<HapticKind, number | number[]> = {
	tap: 10,
	success: [15, 60, 15],
	error: [40, 60, 40, 60, 40],
	warning: 25,
};

const IOS_TICKS: Record<HapticKind, number> = { tap: 1, success: 2, error: 3, warning: 1 };

let iosSwitch: HTMLLabelElement | null = null;

/* iOS Safari has no Vibration API, but toggling a native `switch` checkbox plays the system haptic. */
const iosTick = () => {
	if (typeof document === 'undefined') return;
	if (!iosSwitch) {
		const input = document.createElement('input');
		input.type = 'checkbox';
		input.setAttribute('switch', '');
		input.id = 'scanner-haptic-switch';
		const label = document.createElement('label');
		label.htmlFor = input.id;
		label.setAttribute('aria-hidden', 'true');
		label.style.cssText = 'position:fixed;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
		label.appendChild(input);
		document.body.appendChild(label);
		iosSwitch = label;
	}
	iosSwitch.click();
};

export const haptic = (kind: HapticKind) => {
	try {
		if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
			navigator.vibrate(PATTERNS[kind]);
			return;
		}
		for (let i = 0; i < IOS_TICKS[kind]; i++) setTimeout(iosTick, i * 90);
	} catch {
		// haptics are a nicety; a browser that refuses them changes nothing
	}
};
